<template>
  <div id="Information" class="full_layout information" v-loading.fullscreen="loading">
    <h3 class="informationTitle" v-if="info!=null">{{info.Title}}</h3>
    <div class="informationDetail"v-if="info!=null">
      <div class="informationAuthor">{{info.ReleaseTime}} | {{info.Author}}</div>
      <div v-html="info.Content" ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'informationitme',
  components: { },
  data() {
    return {
      loading: false,
      info:null,
      index:0,
      ps: 24, //pagesize
      pi: 1, //pageindex
    }
  },
  mounted() {},
  created() {
    this.pi=this.$route.query.p||1;
    this.index=this.$route.query.i||0;
    this.getRealtime();
  },
  methods: {
    getRealtime(){
      let that=this;
      that.loading=true;
      let data={PageIndex:that.pi,PageSize:that.ps}
      that.$get(that.$interface.Realtime,data).then(res=>{
        if(res.Result!=0){
          that.info=res.Data[that.index]
          
          document.title = that.info.Title+' - 达咖文化'
        }
        that.loading=false;
      })
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";
.informationDetail{
  line-height: 2;
    letter-spacing: 1px;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/item.vue